import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './auth-guard'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      redirect: '/signin'
    },
    {
      path: '/r/:shortId' // Allow redirection links without modifying the route
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: view('Dashboard/DashboardMainScreen'),
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: view('User/Signin'),
      beforeEnter: AuthGuard
    },
    {
      path: '/loading',
      name: 'LoadingScreen',
      component: view('User/LoadingScreen'),
      beforeEnter: AuthGuard
    },
    {
      path: '/passRecovery',
      name: 'PassRecovery',
      component: view('User/PassRecovery')
    },
    {
      path: '/passChange',
      name: 'PassChange',
      component: view('User/PassChange')
    },
    {
      path: '/reports',
      name: 'Reports',
      component: view('Reports/Reports'),
      beforeEnter: AuthGuard
    },
    {
      path: '/dashboardLiag',
      name: 'DashboardLiag',
      component: view('Dashboard/DashboardLiag')
    },
    {
      path: '/organizationHome',
      name: 'OrganizationHome',
      component: view('OrganizationHome/OrganizationHome'),
      beforeEnter: AuthGuard
    },
    {
      path: '/welcome/:createUserToken',
      name: 'Welcome',
      component: view('Additions/Welcome'),
      beforeEnter: AuthGuard
    },
    {
      path: '/addDevice',
      name: 'AddDevice',
      component: view('Additions/AddDevice'),
      beforeEnter: AuthGuard
    },
    {
      path: '/addUser',
      name: 'AddUser',
      component: view('Additions/AddUser'),
      beforeEnter: AuthGuard
    },
    {
      path: '/addCrop',
      name: 'AddCrop',
      component: view('Additions/AddCrop'),
      beforeEnter: AuthGuard
    },
    {
      path: '/editUser',
      name: 'EditUser',
      component: view('Additions/EditUser'),
      beforeEnter: AuthGuard
    },
    {
      path: '/addField',
      name: 'AddField',
      component: view('Additions/AddField'),
      beforeEnter: AuthGuard
    },
    {
      path: '/manageField',
      name: 'ManageField',
      component: view('OrganizationHome/ManageField'),
      beforeEnter: AuthGuard
    },
    {
      path: '/newCampaignInitialData/:campaignId',
      name: 'NewCampaignInitialData',
      component: view('OrganizationHome/NewCampaignInitialData'),
      beforeEnter: AuthGuard
    },
    {
      path: '/editCampaignDevicesAndServices/:campaignId',
      name: 'EditCampaignDevicesAndServices',
      component: view('Campaigns/EditCampaignDevicesAndServices'),
      beforeEnter: AuthGuard
    },
    {
      path: '/audits/demo',
      name: 'AuditsDemo',
      component: view('Audits/AuditsDemo')
    },
    {
      path: '/audits',
      name: 'Audits',
      component: view('Audits/Audits'),
      beforeEnter: AuthGuard
    },
    {
      path: '/fieldSurveys/:id',
      name: 'FieldSurveyForm',
      component: view('FieldSurveys/FieldSurveyForm'),
      beforeEnter: AuthGuard
    },
    {
      path: '/sharedPluviometricChart/:pluviometricChartId',
      name: 'SharedPluviometricChart',
      component: view('Audits/SharedPluviometricChart'),
    }
  ],
  mode: 'history'
})

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * @param  {string}   name     the filename (basename) of the view to load.
 */
function view (name) {
  return function (resolve) {
    require(['../components/' + name + '.vue'], resolve)
  }
}

router.beforeEach((to, from, next) => {
  if (to.path.includes('/r/')) {
    // If the path includes '/r/', redirect to the loading screen
    return next({ path: '/loading', query: {...to.query, to: to.path} })
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js